module.exports = __webpack_public_path__ + "images/nick_hirannet.jpg?v=946458dca0cd970cb9a855e613f54cf7";